var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_634",
    "data-name": "\\uADF8\\uB8F9 634",
    transform: "translate(-1333 -967)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_32",
    "data-name": "\\uD0C0\\uC6D0 32",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1333 967)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "suitcase",
    d: "M14.75,5.5H12.5V4.75A2.25,2.25,0,0,0,10.25,2.5H8.75A2.25,2.25,0,0,0,6.5,4.75V5.5H4.25A2.25,2.25,0,0,0,2,7.75V14.5a2.25,2.25,0,0,0,2.25,2.25h10.5A2.25,2.25,0,0,0,17,14.5V7.75A2.25,2.25,0,0,0,14.75,5.5ZM8,4.75A.75.75,0,0,1,8.75,4h1.5a.75.75,0,0,1,.75.75V5.5H8Zm7.5,9.75a.75.75,0,0,1-.75.75H4.25a.75.75,0,0,1-.75-.75V10.712H5.75V11.5a.75.75,0,0,0,1.5,0v-.788h4.5V11.5a.75.75,0,0,0,1.5,0v-.788H15.5Zm0-5.25H3.5V7.75A.75.75,0,0,1,4.25,7h10.5a.75.75,0,0,1,.75.75Z",
    transform: "translate(1340.5 974.375)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.cf0d4ed848f00e8fd1b910af28cec9d6.svg";
export { ForwardRef as ReactComponent };